import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=7a6144c6&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=ts&"
export * from "./Stock.vue?vue&type=script&lang=ts&"
import style0 from "./Stock.vue?vue&type=style&index=0&id=7a6144c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6144c6",
  null
  
)

export default component.exports